import { EntityApi } from "../../services/ApiPlatform";

export abstract class StudentSkillApi extends EntityApi {
    protected static GET_COLLECTION = "/api/student-skills";

    protected static POST_COLLECTION = "/api/student-skills";

    protected static GET_ITEM = "/api/student-skills/{id}";

    protected static PUT_ITEM = "/api/student-skills/{id}";

    protected static PATCH_ITEM = "/api/student-skills/{id}";

    protected static DELETE_ITEM = "/api/student-skills/{id}";
}
